import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (
    curPageId: string,
    formConfig: FormConfig,
    formValues: FormValues
): Promise<string | undefined> => {
    switch (curPageId) {
        case 'godt-at-vide':
            return 'dato';

        case 'dato':
            return 'adresse';

        case 'adresse':
            return 'beskriv-skaden';

        case 'beskriv-skaden':
            return 'hvad-er-skadet';

        case 'hvad-er-skadet':
            return 'reparation';

        case 'reparation':
            return 'eventuelle-kommentarer';

        case 'eventuelle-kommentarer':
            return 'dokumentation';

        case 'dokumentation':
            return 'andet-selskab';

        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                return 'hvilket-selskab';
            }

            return 'om-dig';

        case 'hvilket-selskab':
            return 'om-dig';

        case 'om-dig':
            return 'resume';

        case 'resume':
            return undefined;

        default:
            throw new Error('Unknown page: ' + curPageId);
    }
};
